import { useState, useEffect, useCallback } from "react";
import accountService from "../../../../../services/accountService";
import Toaster from "./../../../../../components/common/Toaster";

const IdentificationImages = ({ id }) => {
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchImages = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const result = await accountService.getIdentityDocumentImagesAsync(id);

        if (mounted) {
          setImages(result);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [id]
  );

  useEffect(() => {
    let mounted = true;

    fetchImages(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchImages]);

  return (
    <div className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          {isLoading && (
            <div className="flex-1 space-y-3 py-1 animate-pulse">
              <div className="h-4 bg-gray-100 rounded w-3/5"></div>
              <div className="h-4 bg-gray-100 rounded w-5/5"></div>
              <div className="h-4 bg-gray-100 rounded w-4/5"></div>
              <div className="h-4 bg-gray-100 rounded w-2/5"></div>
            </div>
          )}
          {!isLoading && images.length > 0 && (
            <a
              href={images[0].s3_reference_name}
              target="_blank"
              rel="noreferrer"
            >
              <p className="text-gray-400 text-center text-sm mb-3">Front ID</p>
              <div className="flex justify-center">
                <div className="border dark:border-gray-600 rounded-lg w-36">
                  <img
                    className="object-contain w-36 h-36"
                    alt="Front ID"
                    src={images[0].s3_reference_name}
                  />
                </div>
              </div>
            </a>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          {isLoading && (
            <div className="flex-1 space-y-3 py-1 animate-pulse">
              <div className="h-4 bg-gray-100 rounded w-3/5"></div>
              <div className="h-4 bg-gray-100 rounded w-5/5"></div>
              <div className="h-4 bg-gray-100 rounded w-4/5"></div>
              <div className="h-4 bg-gray-100 rounded w-2/5"></div>
            </div>
          )}
          {!isLoading && images.length > 0 && (
            <a
              href={images[1].s3_reference_name}
              target="_blank"
              rel="noreferrer"
            >
              <p className="text-gray-400 text-center text-sm mb-3">Back ID</p>
              <div className="flex justify-center">
                <div className="border dark:border-gray-600 rounded-lg w-36">
                  <img
                    className="object-contain w-36 h-36"
                    alt="Back ID"
                    src={images[1].s3_reference_name}
                  />
                </div>
              </div>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default IdentificationImages;
